import mapboxgl from "mapbox-gl";

(function () {
    'use strict';

    var geojson = {};
    var map;
    var isTouchDevice = false;

    function MapboxInit() {

        mapboxgl.accessToken = 'pk.eyJ1IjoiYXBleGhvdGVscyIsImEiOiJja2RhMXRpNjkwamRhMnNtaWw0NzZiZzZiIn0.a9_d3rrQoG-B16n3eK4T2Q';

        var strtLatlng = [-0.696796, 54.409898];

        map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/apexhotels/ckda2jofm0szg1ipgsb5nsjrq',
            center: strtLatlng,
            zoom: 4,
            attributionControl: false
        });

        map.addControl(new mapboxgl.AttributionControl(), 'top-left');

        map.on('load', function () {
            console.log('map loaded');
            LocationsMapboxCreateGeoJSON();
            SetInitialPosition();

            const bounds = [
                [-13, 49],
                [10, 59]
            ];

            map.setMaxBounds(bounds);
        });
    }

    // On Mapbox there is no click listener available for the markers. This can be accomplished using the GeoJSON markup they use.
    function LocationsMapboxCreateGeoJSON() {
        // create the initial structure
        geojson = {
            type: 'FeatureCollection',
            features: []
        };

        // Add Destinations
        document.querySelectorAll('.js-hotel-list').forEach(function (destination) {
            var dataContentID = destination.dataset.contentId;
            var longitude = parseFloat(destination.dataset.lng);
            var latitude = parseFloat(destination.dataset.lat);

            var marker = {
                'type': 'Feature',
                'properties': {
                    'markerType': 'destination',
                    'selector': '.js-hotel-list[data-content-id="' + dataContentID + '"]'
                },
                'geometry': {
                    'type': 'Point',
                    'coordinates': [longitude, latitude]
                }
            };

            geojson.features.push(marker);
        });

        // Add Hotels
        document.querySelectorAll('.js-hotel-card').forEach(function (hotel) {
            var dataContentID = hotel.dataset.contentId;
            var longitude = parseFloat(hotel.dataset.lng);
            var latitude = parseFloat(hotel.dataset.lat);

            var marker = {
                'type': 'Feature',
                'properties': {
                    'markerType': 'hotel',
                    'selector': '.js-hotel-card[data-content-id="' + dataContentID + '"]'
                },
                'geometry': {
                    'type': 'Point',
                    'coordinates': [longitude, latitude]
                }
            };

            geojson.features.push(marker);
        });

        // add markers to map
        geojson.features.forEach(function (marker) {

            // create a DOM element for the marker
            var el = document.createElement('div');

            el.innerHTML = '<div class="marker-template"><em class="fas fa-map-marker-alt"></em></div>';

            el.className = marker.properties.markerType + '-marker';
            el.addEventListener('click', function () {
                var target = document.querySelector(marker.properties.selector);
                if (target) ShowCard(target);
            });

            // add marker to map
            new mapboxgl.Marker(el)
                .setLngLat(marker.geometry.coordinates)
                .addTo(map);
        });

        map.on('zoom', function () {
            LocationsMapboxZoomChange(map);
        });
        LocationsMapboxZoomChange(map);
    }

    function LocationsMapboxZoomChange(mapInstance) {
        var zoomLevel = mapInstance.getZoom();
        if (zoomLevel >= 10) {
            document.querySelectorAll('.map-tile .hotel-marker').forEach(function (el) { el.classList.remove('hidden-marker'); });
            document.querySelectorAll('.map-tile .destination-marker').forEach(function (el) { el.classList.add('hidden-marker'); });
        } else {
            document.querySelectorAll('.map-tile .hotel-marker').forEach(function (el) { el.classList.add('hidden-marker'); });
            document.querySelectorAll('.map-tile .destination-marker').forEach(function (el) { el.classList.remove('hidden-marker'); });
        }
    }

    function ShowCard(selectedCard) {
        if (!selectedCard) return;

        // ensure we have an element (in case a selector string was passed)
        var el = typeof selectedCard === 'string' ? document.querySelector(selectedCard) : selectedCard;
        if (!el) return;

        // Show destination card - remove active from siblings
        var listItems = el.closest('.map-list-items');
        if (listItems) {
            listItems.querySelectorAll('.map-menu-container').forEach(function (c) { c.classList.remove('active'); });
        }
        el.classList.add('active');

        // Set the map to the correct position
        var contentType = el.dataset.contentType;

        // Remove the hotel active state so the panel can reduce in size
        listItems.classList.remove('hotel-active');
        if (contentType === 'hotel') {
            // Add the hotel active state so the panel can expand.
            listItems.classList.add('hotel-active');
            var longitude = parseFloat(el.dataset.lng);
            var latitude = parseFloat(el.dataset.lat);
            map.flyTo({ center: [longitude, latitude], zoom: 14 });
        } else if (el.querySelectorAll('.show-on-map').length === 1) {
            var longitude = parseFloat(el.dataset.lng);
            var latitude = parseFloat(el.dataset.lat);
            map.flyTo({ center: [longitude, latitude], zoom: 13 });
        } else {
            // multiple hotels
            var northPosition = -Infinity, eastPosition = -Infinity, southPosition = Infinity, westPosition = Infinity;

            el.querySelectorAll('.show-on-map').forEach(function (destination) {
                var latitude = parseFloat(destination.dataset.lat);
                var longitude = parseFloat(destination.dataset.lng);

                if (!isNaN(latitude)) {
                    northPosition = Math.max(latitude, northPosition);
                    southPosition = Math.min(latitude, southPosition);
                }
                if (!isNaN(longitude)) {
                    eastPosition = Math.max(longitude, eastPosition);
                    westPosition = Math.min(longitude, westPosition);
                }
            });

            if (westPosition !== Infinity && southPosition !== Infinity && eastPosition !== -Infinity && northPosition !== -Infinity) {
                var bounds = new mapboxgl.LngLatBounds(
                    new mapboxgl.LngLat(westPosition, southPosition),
                    new mapboxgl.LngLat(eastPosition, northPosition)
                );

                map.fitBounds(bounds, { padding: 50 });
            }
        }

        if (window.innerWidth < 768) {
            var parentList = el.closest('.map-list-items');
            if (parentList) parentList.style.height = el.offsetHeight + 'px';
        }
    }

    function SetInitialPosition() {
        //mobile stuff
        document.querySelectorAll('.js-mobile-dd').forEach(function (d) { d.style.display = 'none'; d.style.height = '0'; });

        // Get the starting location, this may be a city, hotel or neither in which case we show all the cities.
        var mapboxMapEl = document.querySelector('.mapbox-map');
        if (!mapboxMapEl) return;
        var startLocation = mapboxMapEl.dataset.startLocation;
        var startObj = document.querySelector('.map-menu-container[data-content-id="' + startLocation + '"]');

        if (startObj) {
            ShowCard(startObj);
        }
    }

    function ResizeMapMenu() {
        if (window.innerWidth < 768) {
            var activeItem = document.querySelector('.map-menu-container.active');
            if (activeItem) {
                var parent = activeItem.closest('.map-list-items');
                if (parent) parent.style.height = activeItem.offsetHeight + 'px';
            }
        } else {
            document.querySelectorAll('.map-list-items').forEach(function (el) { el.style.height = ''; });
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        MapboxInit();

        //mobile vars
        isTouchDevice = ('ontouchstart' in document.documentElement);

        document.querySelectorAll('.map-back').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();

                var startLocation = btn.dataset.contentId;
                var startObj = document.querySelector('.map-menu-container[data-content-id="' + startLocation + '"]');

                // Set the start location again
                var mapboxMapEl = document.querySelector('.mapbox-map');
                if (mapboxMapEl) mapboxMapEl.dataset.startLocation = btn.dataset.contentId;

                if (startObj) ShowCard(startObj);
            });
        });

        document.querySelectorAll('.show-on-map').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                if (isTouchDevice) {
                    var ico = el.querySelector('span.header-dropdown i');
                    if (ico) ico.classList.add('flip');
                }

                // Slide the sub menu down / Only do the sliding if the next item is not already visible
                if (el.classList.contains('top-level') && window.innerWidth < 768) {
                    var next = el.nextElementSibling;
                    var nextVisible = next && getComputedStyle(next).display !== 'none';

                    if (!nextVisible) {
                        document.querySelectorAll('.show-on-map.top-level').forEach(function (s) { s.classList.remove('flip-icon'); });
                        el.classList.add('flip-icon');

                        document.querySelectorAll('.map-menu-sub').forEach(function (s) { s.style.display = 'none'; });
                        if (next) next.style.display = 'block';
                    } else {
                        document.querySelectorAll('.show-on-map.top-level').forEach(function (s) { s.classList.remove('flip-icon'); });
                        document.querySelectorAll('.map-menu-sub').forEach(function (s) { s.style.display = 'none'; });
                    }
                }

                var startLocation = el.dataset.contentId;
                var startObj = document.querySelector('.map-menu-container[data-content-id="' + startLocation + '"]');

                // Set the start location again
                var mapboxMapEl = document.querySelector('.mapbox-map');
                if (mapboxMapEl) mapboxMapEl.dataset.startLocation = el.dataset.contentId;

                if (startObj) ShowCard(startObj);

            });
        });

        // By default we need to set the height of the container
        ResizeMapMenu();

        window.addEventListener('resize', function () {
            ResizeMapMenu();
        });
    });

})();
